<div class="alert alert-danger" *ngIf="serverErrors.length">
    <strong>Der skete følgende fejl ved indsendelse:</strong>
    <ul>
        <li *ngFor="let error of serverErrors">{{ error.message }}</li>
    </ul>
</div>
